<p-dialog
  [visible]="visible()"
  (visibleChange)="setVisible($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [appendTo]="'body'"
  [style]="{ width: 'min(960px, 94vw)' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '70vh' }"
  [header]="headerKey() | translate"
  [closable]="!saving()"
  [closeOnEscape]="!saving()"
>
  @if (formError()) {
    <div class="error-message">{{ formError() | translate }}</div>
  }
  <div class="subscription-form">
    <div class="identity">
    <msf-input
      [model]="name()"
      (modelChange)="setName($event)"
      [label]="'Name'"
    ></msf-input>
    <label class="field">
      <span>{{ 'Process' | translate }}</span>
      <app-orchestration-process-select
        [model]="processDefinitionKey()"
        (modelChange)="setProcessDefinitionKey($event)"
        [options]="processOptions()"
        [disabled]="processLocked()"
        [placeholder]="'Process' | translate"
      ></app-orchestration-process-select>
    </label>
    </div>

    @if (visible()) {
      <section class="form-section">
        <app-quartz-schedule-fields
          (validChange)="scheduleValid.set($event)"
          [cronExpression]="cronExpression()"
          (cronExpressionChange)="setCronExpression($event)"
          [timeZoneId]="timeZoneId()"
          (timeZoneIdChange)="setTimeZoneId($event)"
        ></app-quartz-schedule-fields>
      </section>
    }

    <section class="form-section form-section--policy">
      <app-checkbox
        label="Active"
        [ngModel]="isActive()"
        (ngModelChange)="setActive($event)"
      ></app-checkbox>
      <label class="field">
        <span>{{ 'When the run is interrupted' | translate }}</span>
        <msf-select
          [model]="interruptionPolicy()"
          (modelChange)="setInterruptionPolicy($event)"
          [options]="interruptionOptions"
          optionLabel="label"
          optionValue="id"
          translateBy="locale"
          [placeholder]="'When the run is interrupted' | translate"
        ></msf-select>
      </label>
      @if (showResumeLimit()) {
        <div class="field">
          <msf-input
            [model]="resumeAttemptLimit()"
            (modelChange)="setResumeAttemptLimit($event)"
            type="number"
            [min]="1"
            [label]="'Resume attempts' | translate"
          ></msf-input>
          <small class="parameter-help">{{ 'How many times to continue the same assignment after the worker exits.' | translate }}</small>
        </div>
      }
      <div class="field">
        <msf-input
          [model]="pauseAfterConsecutiveFailures()"
          (modelChange)="setPauseAfterConsecutiveFailures($event)"
          type="number"
          [min]="0"
          [label]="'Pause after consecutive failures' | translate"
        ></msf-input>
        <small class="parameter-help">{{ '0 leaves the subscription active.' | translate }}</small>
        <small class="parameter-help">{{ 'Subscription values override the process.' | translate }}</small>
      </div>
      @if (mode() === 'copy') {
        <small class="parameter-help span-all">{{ 'Copy starts inactive' | translate }}</small>
      }
    </section>

    <section class="form-section form-section--parameters">
      <h3>{{ 'Process parameters' | translate }}</h3>
      @if (showSafePreview()) {
        <div class="safe-preview span-all">
          <span>{{ 'Current safe parameter preview' | translate }}</span>
          <pre><code>{{ safePreviewJson() }}</code></pre>
        </div>
      }
      @if (contourLoading()) {
        <app-loading [loading]="true"></app-loading>
      }
      @if (showContourHint()) {
        <small class="parameter-help span-all">{{ 'SATELLITE_DOWNLOAD_CONTOUR_HINT' | translate }}</small>
      }
      @if (showRegionsHint()) {
        <small class="parameter-help span-all">{{ 'SATELLITE_CONTOUR_REGIONS_HINT' | translate }}</small>
      }
      @if (contourStatusKey()) {
        <small class="parameter-help span-all">{{ contourStatusKey() | translate }}</small>
      }
      @if (processDefinitionKey() && !contourLoading() && (mode() === 'create' || contourLoaded())) {
        <app-assignment-start-form
          [processKey]="processDefinitionKey()"
          [seedJson]="parameterSeedJson()"
          [seedIsTemplate]="parameterSeedIsTemplate()"
          [hideAssignmentName]="true"
        ></app-assignment-start-form>
      }
    </section>
  </div>
  <ng-template pTemplate="footer">
    <app-secondary-button
      title="Cancel"
      [disable]="saving()"
      (action)="close()"
    ></app-secondary-button>
    <app-primary-button
      title="Save"
      [loading]="saving()"
      [disable]="!canSave()"
      (action)="save()"
    ></app-primary-button>
  </ng-template>
</p-dialog>
